@if (permission === EFleetShareOption.EDIT) {
  <button
    class="dropdownItem dropdownItem--btn"
    id="editAssetButton"
    data-test="editAssetButton"
    (click)="editAsset()"
  >
    {{ 'edit_asset' | ppTranslate }}
  </button>
}

@if (canAddDashlets && permission === EFleetShareOption.EDIT) {
  <button
    class="dropdownItem dropdownItem--btn"
    id="addDashletButton"
    data-test="addDashletButton"
    (click)="addDashlet()"
  >
    {{ 'add_dashlet' | ppTranslate }}
  </button>
}

<button
  class="dropdownItem"
  id="exportAssetButton"
  data-test="exportAssetButton"
  (click)="exportAsset()"
>
  {{ 'export_asset' | ppTranslate }} ({{ 'pdf' | ppTranslate }})
</button>

@if (permission === EFleetShareOption.EDIT) {
  <button
    class="dropdownItem dropdownItem--btn deleteAssetButton"
    id="deleteAssetButton"
    data-test="deleteAssetButton"
    (click)="deleteAsset()"
  >
    {{ 'delete_asset' | ppTranslate }}
  </button>
}
